<template>
  <div class="infotext">
    <p class="infotext__text">Для заполнения заявления Вам понадобится паспорт, номер ИНН, отчёт об оценке недвижимости (при наличии); необходимо будет скачать, распечатать, подписать и загрузить заявление на заключение договора страхования. <br>При наличии созаёмщиков необходимо будет заполнить на них анкеты данных и приложить копии паспортов</p>
    <p class="infotext__text">Для перехода к заполнению анкеты, пожалуйста, выберете ответы на несколько коротких вопросов</p>
    <div class="infotext__asterisk">*  Поля обязательные для заполнения</div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="sass">
.infotext
  max-width: 286px
  font-size: 14px
  line-height: 24px
  &__text
    color: colors.$brown
    margin-bottom: 32px
  &__asterisk
    color: colors.$gray
</style>